/** Text only: keep numeric ratings unchanged for sorting and calculations. */
export function formatRating(rating, provisional = false) {
  if (rating == null || (typeof rating !== 'number' && typeof rating !== 'string') || String(rating).trim() === '') return '—';
  const value = Number(rating);
  if (!Number.isFinite(value) || value === 0) return '—';
  return `${value}${provisional ? '?' : ''}`;
}
